import { render, staticRenderFns } from "./HkxxcxForm.vue?vue&type=template&id=2084e78e&scoped=true"
import script from "./HkxxcxForm.vue?vue&type=script&lang=js"
export * from "./HkxxcxForm.vue?vue&type=script&lang=js"
import style0 from "./HkxxcxForm.vue?vue&type=style&index=0&id=2084e78e&prod&lang=scss&scoped=true"
import style1 from "./HkxxcxForm.vue?vue&type=style&index=1&id=2084e78e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2084e78e",
  null
  
)

export default component.exports